module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4555e8b691e842b0d459d451bb259f4d.gif";